
import { useState, useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'

interface School {
  id: string
  name: string
  domain: string | null
  created_at: string
  updated_at: string
}

export const useSchools = () => {
  const [schools, setSchools] = useState<School[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        console.log('Fetching schools...')
        const { data, error } = await supabase
          .from('schools')
          .select('*')
          .order('name')
        
        if (error) {
          console.error('Schools fetch error:', error)
          throw error
        }
        
        console.log('Schools fetched:', data)
        setSchools(data || [])
      } catch (error) {
        console.error('Schools fetch error:', error)
        setSchools([])
      } finally {
        setLoading(false)
      }
    }

    fetchSchools()
  }, [])

  return { schools, loading }
}
